import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../assets/logo/Logo.jsx";
import ErrorGif from "../assets/logo/404ErrorGif.jsx";
import notFoundGif from "../assets/gif/404-Error-Animation.gif";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-4xl w-full flex flex-col md:flex-row items-center px-4 gap-0">
        {/* Left content section */}
        <div className="w-full md:w-3/5 text-left flex flex-col">
          {/* Logo at the top */}
          <div className="mb-4 md:mb-0 md:mt-0">
            <Logo 
              className="w-32 h-auto filter-black" 
              style={{ filter: 'brightness(0)' }}
            />
          </div>
          
          <div className="md:mt-6">
            <h1 className="text-9xl font-bold text-black mb-4">Oops!</h1>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              The page you're looking for doesn't exist
            </h2>
            <h3 className="text-2xl text-gray-800 mb-4">Error Code: 404</h3>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              {/* <div className="text-6xl">🚜</div> */}
              <Link
                to="/"
                className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
              >
                Go Back Home
              </Link>
            </div>
          </div>
          
          <div className="mt-8">
            {/* <p className="text-gray-800 text-sm">
              Let's get you back to exploring amazing farms!
            </p> */}
          </div>
        </div>
        
        {/* Right image section */}
        <div className="w-full md:w-2/5 flex justify-center items-center mt-8 md:mt-0">
          <ErrorGif 
            imagePath={notFoundGif}
            altText="404 Error - Page not found"
            className="w-full max-w-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
